import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './admin.component';
import { AdminGuard } from '../@auth/guards/admin.guard';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: '',
        redirectTo: 'users/list',
        canActivate: [AdminGuard],
        pathMatch: 'full',
      },
      {
        path: 'users',
        canActivate: [AdminGuard],
        loadChildren: () =>
          import('./users/users.module').then((m) => m.UsersModule),
      },
      {
        path: 'subscriptions',
        canActivate: [AdminGuard],
        loadChildren: () =>
          import('./subscriptions/subscriptions.module').then(
            (m) => m.SubscriptionsModule,
          ),
      },
      {
        path: 'foods',
        canActivate: [AdminGuard],
        loadChildren: () =>
          import('./public-foods/public-foods.module').then(
            (m) => m.PublicFoodsModule,
          ),
      },
      {
        path: 'templates',
        canActivate: [AdminGuard],
        loadChildren: () =>
          import('./public-templates/public-templates.module').then(
            (m) => m.PublicTemplatesModule,
          ),
      },
      { path: '**', redirectTo: '' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AdminRoutingModule {}
